export const ROOT_FONT_SIZE_IN_PX = 14;
export const HTML_FONT_SIZE_IN_PX = 16;
export const BUTTON_HEIGHT_IN_PX = 40;
export const INPUT_SMALL_HEIGHT_IN_PX = 28;
export const INPUT_HEIGHT_IN_PX = 40;
